export default __webpack_public_path__ + "static/media/roi-calculator.615ff618.png";